import en from './en';

// Checking the language chosen
const LocalStrings = en;
export default LocalStrings;
